import API from "@/utils/API/API";
import assign from 'lodash/assign';
import Config from '@/config';

const defaultAdviser = Config.get('DEFAULT_ADVISER');

export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_REQUESTED = 'FETCH_DATA_REQUESTED';

export const initState = {
  isFetched: false,
  isFetching: false,
  data: null,
};

export const mutations = {
  [FETCH_DATA_REQUESTED](state) {
    assign(state, { isFetching: true });
  },

  [FETCH_DATA_SUCCESS](state, data) {
    assign(state, {
      isFetching: false,
      isFetched: true,
      data,
    });
  },
};

export const actions = {
  async fetch({ commit }, { adviserId } = {}) {
    try {
      if(!adviserId) throw new Error('No adviserId supplied');

      const data = await API.advisers(adviserId);
      data.real_adviser_id = adviserId

      commit(FETCH_DATA_SUCCESS, data);
    } catch (e) {
      commit(FETCH_DATA_SUCCESS, defaultAdviser);
    }

    return Promise.resolve();
  },
};

export const getters = {
  adviser: state => state.data,
};

export default {
  namespaced: true,

  state: { ...initState },

  mutations,

  actions,

  getters,
};